import CustomElement from '../core/custom.js'

const SELECTORS = {
  nextBtn: '.js-load-more-next-btn'
}

export default window.customElements.define(
  'load-more',
  class extends CustomElement {
    constructor() {
      super()

      this.fetch = this.fetch.bind(this)

      this.events = {
        [`click ${SELECTORS.nextBtn}`]: 'onClickNextBtn'
      }
    }

    connectedCallback() {
      super.connectedCallback()

      this.$nextBtn = this.querySelector(SELECTORS.nextBtn)

      requestAnimationFrame(() => {
        this.classList.add('transition-in')
      })

      if (this.$nextBtn) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.onClickNextBtn()
            }
          })
        })

        this.observer.observe(this.$nextBtn)
      }
    }

    disconnectedCallback() {
      super.disconnectedCallback()

      if (this.observer) {
        this.observer.unobserve(this.$nextBtn)
        this.observer.disconnect()
      }
    }

    onClickNextBtn(e) {
      if (e) {
        e.preventDefault()
      }

      let url = this.$nextBtn.href
      window.history.replaceState({}, '', url)

      this.fetch(url)
    }

    fetch(url) {
      this.setData({ loading: true })
      this.$nextBtn.classList.add('is-loading')

      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const dom = new DOMParser().parseFromString(responseText, 'text/html')

          const content = dom.querySelector(this.tagName)

          this.$nextBtn.remove()
          this.parentElement.appendChild(content)

          this.setData({ loading: false })
        })
    }
  }
)
